module.exports = __webpack_public_path__ + "static/img/1029_small.5e90b48.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1029_small.png
// module id = 0xD6
// module chunks = 1